var GlobalEventEmitter = /** @class */ (function () {
    function GlobalEventEmitter() {
    }
    // constructor() {
    //     this._handlers = {};
    // }
    GlobalEventEmitter.on = function (eventName, callback) {
        var callbacks = this._handlers[eventName] || [];
        callbacks.push(callback);
        this._handlers[eventName] = callbacks;
        return this;
    };
    // static off(eventName, callback) {
    //     let callbacks = this._handlers[eventName];
    //     this._handlers[eventName] = callbacks && callbacks.filter(fn => fn !== callback);
    //     return this;
    // }
    GlobalEventEmitter.off = function (eventName) {
        this._handlers[eventName] && (delete this._handlers[eventName]);
        return this;
    };
    GlobalEventEmitter.emit = function (eventName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var callbacks = this._handlers[eventName];
        callbacks && callbacks.forEach(function (fn) { return fn.apply(args); });
        return this;
    };
    GlobalEventEmitter.once = function (eventName, callback) {
        var _this = this;
        var wrapFunc = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            callback.apply(args);
            // this.off(eventName, wrapFunc);
            _this.off(eventName);
        };
        this.on(eventName, wrapFunc);
        return this;
    };
    GlobalEventEmitter._handlers = {};
    return GlobalEventEmitter;
}());
export { GlobalEventEmitter };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/services/global.event.emitter.ts.pre-build-optimizer.js